import React from 'react';
import {useMatches} from '@remix-run/react';

//domains
import type {SanityProductQueryResponse} from '~/domains/product';

export default function ProductDetailsQuantity({
  quantity,
  setQuantity,
  quantityAvailable,
}: {
  quantity: number;
  setQuantity: React.Dispatch<React.SetStateAction<number>>;
  quantityAvailable: number;
}) {
  const matches = useMatches();
  const routeData = matches.find(
    (m) => m.id === 'routes/($lang)/products/$productHandle',
  )?.data;
  const productSettings =
    routeData.productSettings as SanityProductQueryResponse['productSettings'];
  return (
    <div className="quantity order-2 flex-1 lg:order-1">
      <span className="mb-3 block font-medium">
        {productSettings?.product_settings_translations?.quantity_label ??
          'Quantity'}{' '}
        :
      </span>
      <div className="">
        <div className="item-center relative flex min-h-[38px] min-w-[180px] overflow-hidden rounded-md bg-hk-deep-gray text-center">
          <div className="absolute left-0 top-0 h-full">
            <button
              onClick={() =>
                setQuantity((prevValue) =>
                  prevValue !== 1 && prevValue > 0 ? prevValue - 1 : 1,
                )
              }
              className="h-full bg-black px-4 text-[24px] text-white"
            >
              -
            </button>
          </div>
          <div className="flex w-full items-center">
            <input
              className="w-full bg-transparent px-[50px] text-center outline-none"
              value={quantity}
              type="text"
              onChange={(e) => {
                if (e.target.value) {
                  const newQuantity = parseInt(
                    e.target.value.replace(/[^0-9]+/g, ''),
                  );
                  if (newQuantity < quantityAvailable) {
                    setQuantity(newQuantity);
                  }
                  if (newQuantity >= quantityAvailable) {
                    setQuantity(quantityAvailable);
                  }
                }
              }}
            />
          </div>
          <div className="absolute right-0 top-0 h-full">
            <button
              onClick={() =>
                setQuantity((prevValue) =>
                  prevValue < quantityAvailable ||
                  (prevValue < quantityAvailable && quantityAvailable)
                    ? prevValue + 1
                    : prevValue,
                )
              }
              className="h-full bg-black px-4 text-[24px] text-white"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
